var map = {
  "./fill_dark.module.css": "2023",
  "./fill_error_primary.module.css": "1068",
  "./fill_error_secondary.module.css": "5428",
  "./fill_light.module.css": "6519",
  "./fill_primary.module.css": "7205",
  "./fill_secondary.module.css": "7029",
  "./fill_success_primary.module.css": "1913",
  "./fill_success_secondary.module.css": "4417",
  "./fill_warning_primary.module.css": "8650",
  "./fill_warning_secondary.module.css": "2470",
  "./fill_white_primary.module.css": "3215",
  "./fill_white_secondary.module.css": "699",
  "./stroke_primary.module.css": "2212",
  "./stroke_secondary.module.css": "1900",
  "./stroke_white_secondary.module.css": "1978"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2413;
